import { useSelector } from "react-redux";

import { usePageActions } from "store/PageSlice";

const usePage = () => {
  const { loadPage, resetPage } = usePageActions();

  const { page } = useSelector((state) => state.PageSlice);

  return {
    loadPage,
    page,
    resetPage,
  };
};

export default usePage;
